// Global Instructions Rule Applied!
//
// One cfg.pipeline_outcomes row as it rides in the global-configs payload —
// what a pipeline process ends AS (Invested / Not invested / Declined / Open).
//
// A TOP-LEVEL key rather than a synthesised lookup group, for the same reason
// cfg.fund_statuses is one: a lookup detail has nowhere to carry a tag colour
// or a pipeline type, and those are the point. `label` is rendered directly,
// so renaming an outcome in Configuration changes the app with no deploy;
// `outcome_key` is the stable machine key code matches on and never renames.
//
// MUST stay in lockstep with the Python twin in
// backend/src/data_manager/data_models/global_config_record.py and with
// get_global_configs_v3 — both records are .strict(), so a key the RPC emits
// and a model lacks is a hard failure, not a degraded field.
import { z } from 'zod'

export const PipelineOutcomeModelSchema = z
  .object({
    id: z.string(),
    pipeline_type_id: z.string(),
    pipeline_type_key: z.string(),
    outcome_key: z.string(),
    label: z.string(),
    tag_color: z.string().nullish(),
    sort_order: z.number().nullish()
  })
  .strict()

export type PipelineOutcomeModel = z.infer<typeof PipelineOutcomeModelSchema>
